import { Component, OnInit, OnDestroy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { BroadcastService } from '@azure/msal-angular';
import { LoginAwareComponent } from '../login-aware-component';
import { GRAPH_SCOPES } from '../msal.constants';
import { GraphClientService } from '../services/graph-client-service';
import { DiagnosticsServiceFactory } from '../services/diagnostics-service-factory';

/**
 * Shown only to authenticated users, this compnent dynamically detects the name of the current
 * user, and determines time of day. It then combines the name and time of day into
 * a personalized greeting displayed prominently on the page.
 */
@Component({
  selector: 'app-greeter',
  templateUrl: './greeter.component.html',
  styleUrls: ['./greeter.component.scss']
})
export class GreeterComponent extends LoginAwareComponent implements OnInit, OnDestroy {
  private greeting = '';
  private graphClient: GraphClientService;

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    broadcastService: BroadcastService,
    authService: MsalService,
    graphClient: GraphClientService) {
    super(diagnosticsFactory.create('GreeterComponent'), broadcastService, authService);
      this.graphClient = graphClient;
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.loggedIn) {
      this.setGreeting();
    }
  }

  protected onLoginSuccess(token: any) {
    this.loggedIn = true;
    this.setGreeting();
  }

  private setGreeting(): void {
    this.authorize(GRAPH_SCOPES).then(token => {
      this.graphClient.getData(this.constructor.name, token).subscribe(
        data => {
          this.greeting = this.formatGreeting(data['displayName'] as string);
        }, error => {
          this.diagnostics.logError('Error accessing user profile: ' + JSON.stringify(error));
        });
    }).catch(reason => {
      this.handleAcquireTokenFailure(reason);
    });
  }

  private formatGreeting(userName: string): string {
    const localHours = new Date().getHours();
    const name: string = (userName) ? userName : 'User';

    if (localHours > 20 || localHours < 4) {
      return `Good night, ${name}`;
    } else if (localHours < 12) {
      return `Good morning, ${name}`;
    } else if (localHours < 17) {
      return `Good afternoon, ${name}`;
    } else {
      return `Good evening, ${name}`;
    }
  }
}
